import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { FaHeart } from "react-icons/fa";
import background from '../img/background.png';
import About from './About';
import SocialMedia from './SocialMedia';
import Services from './Services';

const Home = () => {
  const [isDetailsVisible, setDetailsVisibility] = useState(false);

  const toggleDetails = () => {
    setDetailsVisibility(!isDetailsVisible);
  };

  return (
    <>
      <div className="hero">
        <div className="hero-content">
          <h1>PORTLAND BASED STUDIO</h1>
          <h2>Korean Nail Artist</h2>
          <br />
          <div className="button-container">
            {/* <Link to="/about" className="btn btn-dark explore">
              LEARN MORE 
              <MdKeyboardDoubleArrowRight className='icons' />
            </Link> */}
            <Link to="/contact" className="btn btn-dark book-now">
              BOOK NOW 
              <MdKeyboardDoubleArrowRight className='icons' />
            </Link>
          </div>
        </div>
      </div>
      <About />
      <Services />
      <SocialMedia />
    </>
  );
};

export default Home;
